import { Navigate, Outlet } from "react-router-dom";
import { useParams, useLocation } from "react-router";

import { UserValidator, setGlobalState, get_search_parameters } from "functions";
import Nav from "pages/generic_components/navbar.js";

export default function AuthedRoutes() {
	let params = Object.assign(get_search_parameters(), useParams());
	setGlobalState("params", params);
	let location = useLocation();
	setGlobalState("location", location);

	let checker = new UserValidator();
	let is_logged_in = checker.logged_id();

	return is_logged_in ? (
		<div>
			{!location.pathname.includes("session") ? <Nav /> : null}
			<Outlet />
		</div>
	) : (
		<Navigate to="/login" />
	);
}
